<i18n>
  {
    "pt_BR": {
      "providers": {
        "paypal": "Paypal",
        "pagseguro": "Pagseguro"
      },
      "status": {
        "paid": "Pago",
        "waiting": "Em processamento",
        "created": "Criada",
        "refunded": "Estornada",
        "cancelled": "Cancelada"
      }
    }
  }
</i18n>

<template>
  <vue-good-table
    v-bind="options"
    >
    <template slot="table-row" slot-scope="props">
      <template v-if="props.column.field == 'actions'">
        <button @click.prevent="update(props.row)" v-text="props.row.status_original == 'paid' ? 'Reembolsar Fatura' : 'Marcar fatura como paga'"></button>
      </template>
      <template v-else>
        {{ props.formattedRow[props.column.field] }}
      </template>
    </template>
  </vue-good-table>
</template>

<script>
  const format = 'DD/MM/YY HH:mm';

  export default {
    props: {
      invoices: {
        type: Array,
        required: true,
      },

      root: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      parsed () {
        return this.invoices.map((invoice) => ({
          ...invoice,
          provider: this.$t('providers.' + invoice.provider),
          status: this.$t('status.' + invoice.status),
          status_original: invoice.status,
          total: Number(invoice.total / 100).toLocaleString(),
        }));
      },

      options () {
        const options = {
          columns: this.columns,
          rows: this.parsed,
          searchOptions: {
            enabled: true,
            placeholder: 'Pesquisar',
          },
          sortOptions: {
            enabled: true,
            initialSortBy: {field: 'id', type: 'desc'}
          },
          paginationOptions: {
            enabled: true,
            mode: 'records',
            perPage: 20,
            position: 'top',
            perPageDropdown: [10, 20, 50, 100],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'Próximo',
            prevLabel: 'Anterior',
            rowsPerPageLabel: 'Resultados por página',
            ofLabel: 'of',
          },
        };

        return options;
      },

      columns () {
        const columns = [
          {
            label: 'ID',
            field: 'id',
            type: 'number',
          },
          {
            label: 'Data',
            field: 'created_at',
            type: 'date',
            dateInputFormat: format,
            dateOutputFormat: format,
          },
          {
            label: 'Total R$',
            field: 'total',
          },
          {
            label: 'Status',
            field: 'status',
          },
          {
            label: 'Provedor',
            field: 'provider',
          },
        ];

        if (this.root) {
          return [
            ...columns,
            {
              label: 'Usuário',
              field: 'user.email',
            },
            {
              label: 'Ações',
              field: 'actions',
              sortable: false,
            },
          ];
        }

        return columns;
      },
    },

    methods: {
      update (row) {
        this.$emit('update', row.id, row.status_original);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Invoice/Table.vue